import React, { useEffect, useRef } from 'react';

const LottiePlayer = ({ speed = 1, path, loop, autoplay, style = {} }) => {
    const containerRef = useRef();

    useEffect(() => {
        if (containerRef.current && window.lottie) {
            const animation = window.lottie.loadAnimation({
                container: containerRef.current,
                renderer: 'svg',
                loop,
                autoplay,
                path
            });
            animation.setSpeed(speed);
            return () => animation.destroy();
        }
    }, [path, autoplay, loop, speed]);

    return <div ref={containerRef} style={style}></div>
};

export default LottiePlayer;